export enum LogLevel {
  'debug' = 'debug',
  'info' = 'info',
  'log' = 'log',
  'warn' = 'warn',
  'error' = 'error',
}
